import { Col, Form, FormProps, Input, Modal, ModalProps, Row, Select, useSelect, message } from '@pankod/refine-antd'
import React, { useEffect } from 'react'
import { DatePicker } from 'antd'
import { IReportTheme } from 'interfaces'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs from 'dayjs'
import moment from 'moment'
import { findProjectFieldName } from 'gql/query'

interface IEditProjectConfig {
  modalProps: ModalProps
  formProps: FormProps
  refetchData: () => void
}
const ProjectConfigEdit: React.FC<IEditProjectConfig> = ({ modalProps, formProps, refetchData }) => {
  const { RangePicker } = DatePicker
  // const { selectProps: reportThemeProps } = useSelect<IReportTheme>({
  //   resource: 'report_themes',
  //   fetchSize: 10000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    return current && current < dayjs().add(0, 'day')
  }

  useEffect(() => {
    if (formProps?.initialValues?.duration) {
      const { start_date, end_date } = formProps.initialValues.duration
      formProps.initialValues.duration = [moment(start_date, 'DD-MM-YYYY'), moment(end_date, 'DD-MM-YYYY')]
    }
  }, [formProps?.initialValues])

  const onSubmit = async (values: any) => {
    try {
      if (values && values?.name?.trim() && values?.duration?.length === 2) {
        const duration: { start_date?: string; end_date?: string } = {}
        //formating the duration of the project
        duration.start_date = values.duration[0].format('DD-MM-YYYY') || ''
        duration.end_date = values.duration[1].format('DD-MM-YYYY') || ''
        values.name = values?.name?.trim().toLowerCase()
        values.duration = duration
        //check name is updated or not
        const isNameStillSame = values?.name === formProps?.initialValues?.name
        //if name is not same then checking duplicate
        if (!isNameStillSame) {
          const isPresent: any = await findProjectFieldName(values?.name, 'name','project_config')
          //if it duplicate then returning
          if (isPresent && isPresent?.project_config?.length > 0) {
            message.error('Project name is already present... please make sure projects are unique')
            return false
          }
        }
        return formProps.onFinish && formProps.onFinish(values)
      } else {
        message.error("Can't proceed, expected values are missing...")
        return false
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <Modal {...modalProps} title="Edit Project Configuration">
      <Form
        {...formProps}
        onFinish={values =>
          onSubmit(values)
            .then((res: any) => {
              if (res && res?.data?.id) {
                message.success('Updated successfully...')
              }
            })
            .catch(err => message.error('Updation failed, Please try again later...'))
        }
      >
        <Row gutter={[24, 0]}>
          <Col xs={24} lg={8}>
            {/* project name */}
            <Form.Item
              label="Project Name"
              name="name"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: 'Please add an name',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          {/* description */}
          <Col xs={24} lg={8}>
            <Form.Item label="Description" name="description" labelCol={{ span: 24 }}>
              <Input />
            </Form.Item>
          </Col>
          {/* date */}
          <Col xs={24} lg={8}>
            <Form.Item
              label="Duration"
              name="duration"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: 'please select the project duration' }]}
            >
              <RangePicker format="DD-MM-YYYY" disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          {/* report theme */}
          {/* <Col xs={24} lg={24}>
            <Form.Item label="Report Themes" name="report_theme_ids" labelCol={{ span: 24 }}>
              <Select {...reportThemeProps} mode="multiple" />
            </Form.Item>
          </Col> */}
        </Row>
      </Form>
    </Modal>
  )
}

export default ProjectConfigEdit
